var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundOnIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1361 4.40228C14.9553 3.96068 12.4496 5.36219 10.376 7.19579H8.84C7.82157 7.19579 6.84484 7.60042 6.12471 8.32055C5.40456 9.0407 5 10.0174 5 11.0358V12.9558C5 13.9742 5.40456 14.951 6.12471 15.6712C6.84484 16.3913 7.82157 16.7958 8.84 16.7958H10.376C12.4016 18.6582 14.9073 20.031 16.1361 19.599C18.1521 18.8502 18.488 14.799 18.488 11.9958C18.488 9.19259 18.1521 5.15108 16.1361 4.40228Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundOnIcon);
export default __webpack_public_path__ + "static/media/SoundOnIcon.8a1378c8b6162e3479145fa3d38c1396.svg";
export { ForwardRef as ReactComponent };